import { DiamondBlue } from '@prophecy/icons/GemIcons';
import { BaseColor } from '@prophecy/theme';

function getUnknownGem() {
  return {
    icon: DiamondBlue,
    iconName: 'DiamondBlue',
    tone: BaseColor.blue,
    CategoryName: 'UNKNOWN_GEM'
  } as const;
}

export const UNKNOWN_GEM = getUnknownGem();
export function getUnknownGemName() {
  return getUnknownGem().CategoryName;
}
